/** Montant en lettres (français) pour documents commerciaux — FCFA. */

const UNITS = [
  '',
  'un',
  'deux',
  'trois',
  'quatre',
  'cinq',
  'six',
  'sept',
  'huit',
  'neuf',
  'dix',
  'onze',
  'douze',
  'treize',
  'quatorze',
  'quinze',
  'seize',
  'dix-sept',
  'dix-huit',
  'dix-neuf',
];
const TENS = [
  '',
  '',
  'vingt',
  'trente',
  'quarante',
  'cinquante',
  'soixante',
  'soixante',
  'quatre-vingt',
  'quatre-vingt',
];

function underHundred(n: number): string {
  if (n < 20) return UNITS[n] ?? '';
  if (n < 70) {
    const t = Math.floor(n / 10);
    const u = n % 10;
    if (u === 1 && t !== 8) return `${TENS[t]}-et-un`;
    return u ? `${TENS[t]}-${UNITS[u]}` : TENS[t]!;
  }
  if (n < 80) {
    const u = n - 60;
    if (u === 1) return 'soixante-et-un';
    return u ? `soixante-${UNITS[u]}` : 'soixante';
  }
  const u = n - 80;
  if (u === 0) return 'quatre-vingts';
  return `quatre-vingt-${UNITS[u]}`;
}

function underThousand(n: number): string {
  if (n < 100) return underHundred(n);
  const h = Math.floor(n / 100);
  const r = n % 100;
  const head = h === 1 ? 'cent' : `${UNITS[h]} cent${r === 0 && h > 1 ? 's' : ''}`;
  return r ? `${head} ${underHundred(r)}` : head;
}

function chunkToWords(n: number): string {
  if (n === 0) return '';
  if (n < 1000) return underThousand(n);
  const millions = Math.floor(n / 1_000_000);
  const restM = n % 1_000_000;
  const thousands = Math.floor(restM / 1000);
  const rest = restM % 1000;
  const parts: string[] = [];
  if (millions) {
    parts.push(
      millions === 1 ? 'un million' : `${underThousand(millions)} millions`,
    );
  }
  if (thousands) {
    const thWords =
      thousands === 1
        ? 'mille'
        : `${underThousand(thousands).replace(/\bcents\b/g, 'cent')} mille`;
    parts.push(thWords);
  }
  if (rest) parts.push(underThousand(rest));
  return parts.join(' ');
}

/** Ex. 399316 → « trois cent quatre-vingt-dix-neuf mille trois cent seize francs CFA » */
export function montantEnLettresFcfa(amount: number): string {
  const n = Math.round(Math.abs(amount));
  if (n === 0) return 'zéro franc CFA';
  const words = chunkToWords(n);
  const capitalized = words.charAt(0).toUpperCase() + words.slice(1);
  return `${capitalized} francs CFA`;
}
